import React from "react";
import { useProductName } from "store/selectors/branding";

export const WellSkyDedicatedUserNote: React.FC = () => {
    const productName = useProductName();
    return (
        <p className="text-sm text-gray-700">
            Create a WellSky user just for {productName}, with access to prospects and
            referral sources, and enter its username and password. Don&apos;t use a super
            admin or someone&apos;s own login.
        </p>
    );
};
